import { render, staticRenderFns } from "./RelationLogTable.vue?vue&type=template&id=19fd7396&scoped=true"
import script from "./RelationLogTable.vue?vue&type=script&lang=js"
export * from "./RelationLogTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fd7396",
  null
  
)

export default component.exports